
const MAX_PART = 1000

export function semverParse (ver: string) {
  const parts = ver.match(/(\d+)(?:.(\d+)(?:.(\d+))?)?/)
  if (!parts) {
    return null
  }
  const [, major, minor, patch] = parts.map((n) => parseInt(n, 10) || 0)
  return { major, minor, patch }
}

function semverToNumber (ver: string) {
  const verParts = semverParse(ver)
  if (!verParts) {
    return null
  }

  const { major, minor, patch } = verParts
  return [major, minor, patch].reduce((acc, num) => (acc * MAX_PART + num), 0)
}

export function semverGte (verA: string, verB: string) {
  const numA = semverToNumber(verA)
  const numB = semverToNumber(verB)
  if (numA === null || numB === null) {
    return null
  }
  return numA >= numB
}
